/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { Subscription } from 'rxjs'
import { TranslationService } from 'src/app/shared/service/translation.service';
@Component({
  selector: 'app-group-section',
  templateUrl: './group-section.component.html',
  styleUrls: ['./group-section.component.scss']
})
export class GroupSectionComponent implements OnInit, OnDestroy {
  // Feature flags
  public enableManageBusiness: boolean = false;
  public enableManageFleet: boolean = false;
  public enableStatsDashboard: boolean = false;

  constructor(
    private readonly route: Router,
    private readonly dataSharing: SharingDataService,
    private readonly cdr: ChangeDetectorRef,
    private readonly translationService: TranslationService
  ) { }

  @ViewChild('viewContainerRef', { read: ViewContainerRef, static: true })
  public viewContainer: ViewContainerRef | undefined
  groupName: any
  profileswitchselected: boolean = false
  subscriptions: Subscription[] = []
  translationData: any
  profileImage: any

  private checkDashboardVisibility(): void {
    const flag = this.translationService.featureFlags.profile;
    const allowedProfiles: string[] = (flag as any).statsDashboardAllowedProfiles ?? [];
    const currentProfile = localStorage.getItem('aliasGroupName') ?? '';
    this.enableStatsDashboard = (flag.enableStatsDashboard ?? false) &&
      (allowedProfiles.length === 0 || allowedProfiles.includes(currentProfile));
  }

  ngOnInit(): void {
    this.dataSharing.getProfileChanged().subscribe(() => {
      this.groupName = localStorage.getItem('profileName')
      this.profileImage = localStorage.getItem('profileImage')
      this.checkDashboardVisibility();
    })
    this.groupName = localStorage.getItem('profileName')
    this.profileImage = localStorage.getItem('profileImage')
    this.enableManageBusiness = this.translationService.featureFlags.profile.enableManageBusiness;
    this.enableManageFleet = this.translationService.featureFlags.profile.enableManageFleet;
    this.checkDashboardVisibility();
  }


  manageBusiness() {
    this.dataSharing.setMobileMenuStatus(false);
    this.route.navigate(['profile/member-list'])
    this.dataSharing.setProfileDetailsClicked(true)
  }
  switchProfile(event: any) {
    event.stopPropagation();
    this.profileswitchselected = true
    this.dataSharing.setProfileSwitched(true)
    this.cdr.detectChanges()
    localStorage.setItem("isProfileChanged", 'true')
  }

  public myFleets(): void {
    this.dataSharing.setMobileMenuStatus(false);
    this.route.navigate(['profile/fleet'])
  }

  public navigateToDashboard(): void {
    this.dataSharing.setMobileMenuStatus(false);
    this.route.navigate(['events/stats-dashboard']);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe())
  }
}
